import { isRecord } from '@main/shared/utils';

export function nullToUndefined<T>(value: T): T {
  if (value === null) return undefined as T;
  if (Array.isArray(value)) return value.map(nullToUndefined) as T;
  if (value instanceof Date) return value;
  if (typeof value === 'object' && value !== null) {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, nullToUndefined(v)])) as T;
  }
  return value;
}

export function pickDirtyValues(values: unknown, dirtyFields: unknown): Record<string, unknown> {
  if (!isRecord(values) || !isRecord(dirtyFields)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(dirtyFields).flatMap(([key, dirty]) => {
      const value = values[key];
      if (dirty === true) {
        return value === undefined ? [] : [[key, value]];
      }

      if (Array.isArray(dirty)) {
        return value === undefined || !hasDirtyValues(dirty) ? [] : [[key, value]];
      }

      const nested = pickDirtyValues(value, dirty);
      return Object.keys(nested).length === 0 ? [] : [[key, nested]];
    }),
  );
}

export function hasDirtyValues(dirtyFields: unknown): boolean {
  if (dirtyFields === true) {
    return true;
  }

  if (Array.isArray(dirtyFields)) {
    return dirtyFields.some(hasDirtyValues);
  }

  if (isRecord(dirtyFields)) {
    return Object.values(dirtyFields).some(hasDirtyValues);
  }

  return false;
}
